/**
 * @exports объект конфига API, содержащий адрес сервера, токен
 */
export const apiConfig = {
  serverLink: "https://mesto.nomoreparties.co/v1/cohort-54",
  headers: {
    authorization: "7b813897-5964-428c-86c0-44432f9d08b4",
    "Content-Type": "application/json",
  },
};
